import React, { Component } from 'react'
import * as THREE from 'three'
import SVGLoader from 'three-svg-loader'
import { dispose3DObject } from '../../../utils'

class Sprite3D extends Component {
    constructor(props) {
        super(props)
        this.rootObj
    }

    state = {
        spriteScale: {
            x: 4,
            y: 4,
            z: 4,
        },
    }

    componentDidMount() {
        const { rootObj } = this.props
        this.rootObj = rootObj
        this.mountSprite()
    }

    componentWillUnmount() {
        dispose3DObject(this.spriteContainer)
    }

    componentDidUpdate(prevProps) {
        const { isVisible, spriteResource } = this.props

        if (!isVisible && prevProps.isVisible) {
            this.disposeSprites()
            this.rootObj.needsUpdate = true
        } else if (isVisible && !prevProps.isVisible) {
            this.mountSprite()
            this.rootObj.needsUpdate = true
        } else if (prevProps.spriteResource && spriteResource !== prevProps.spriteResource) {
            this.replaceSprite()
            this.rootObj.needsUpdate = true
        }
    }

    replaceSprite = () => {
        this.disposeSprites()
        this.mountSprite()
    }

    disposeSprites = () => {
        this.spriteContainer.children.forEach((sprite, i) => {
            dispose3DObject(sprite)
        })
    }

    mountSprite = () => {
        const {
            spriteResource,
            containerWidth,
            containerHeight,
            meshPosition,
            spriteScale,
            camera,
            renderer,
        } = this.props
        // Maintain reference to existing spriteContainer so animations stay bound
        if (!this.spriteContainer) {
            this.spriteContainer = new THREE.Object3D()
            this.spriteContainer.name = 'spriteContainer'
        } else {
            this.spriteContainer.children = []
        }

        let spriteResourceArray = spriteResource.split('.')
        let spriteResourceFileType = spriteResourceArray[spriteResourceArray.length - 1]
        if (spriteResourceFileType === 'svg') {
            new SVGLoader().load(spriteResource, paths => {
                // https://stackoverflow.com/questions/37647853/three-js-depthwrite-vs-depthtest-for-transparent-canvas-texture-map-on-three-p

                // Creates sprite container so that three.js elements can be managed and disposed of if sprite resource is swapped out
                var spriteGroup = new THREE.Group()

                for (var i = 0; i < paths.length; i++) {
                    var path = paths[i]

                    // https://github.com/mrdoob/three.js/issues/12737
                    // Override render order
                    // https://stackoverflow.com/questions/15514274/three-js-how-to-control-rendering-order
                    // https://stackoverflow.com/questions/12666570/how-to-change-the-zorder-of-object-with-threejs
                    // https://stackoverflow.com/questions/15994944/transparent-objects-in-threejs/15995475#15995475
                    var material = new THREE.MeshBasicMaterial({
                        color: path.color,
                        side: THREE.DoubleSide,
                        depthTest: false,
                        depthWrite: false,
                    })
                    var shapes = path.toShapes(true)

                    for (var j = 0; j < shapes.length; j++) {
                        var shape = shapes[j]
                        var geometry = new THREE.ShapeBufferGeometry(shape)
                        var mesh = new THREE.Mesh(geometry, material)
                        spriteGroup.add(mesh)
                    }
                }
                spriteGroup.scale.set(0.02 * containerWidth, 0.04 * containerHeight, 0.015)

                spriteGroup.position.set(-0.2, 0.23, 0)
                spriteGroup.rotateX(THREE.Math.degToRad(180))
                spriteGroup.name = 'sprite'
                this.spriteContainer.add(spriteGroup)
                if (meshPosition) this.spriteContainer.position.set(meshPosition.x, meshPosition.y, meshPosition.z)

                this.rootObj.add(this.spriteContainer)
            })
        } else {
            var spriteMap = new THREE.TextureLoader().load(spriteResource)

            var spriteMaterial = new THREE.SpriteMaterial({
                map: spriteMap,
                color: 0xffffff,
                // sizeAttenuation: false
            })

            var obj = new THREE.Sprite(spriteMaterial)
            obj.name = 'sprite'
            obj.opacity = 1
            obj.material.transparent = true
            obj.renderOrder = 10

            this.spriteContainer.add(obj)
            this.spriteContainer.name = 'spriteContainer'

            this.rootObj.add(this.spriteContainer)

            if (meshPosition) obj.position.set(meshPosition.x, meshPosition.y, meshPosition.z)

            if (spriteScale) obj.scale.set(spriteScale.x, spriteScale.y, spriteScale.z)
        }
    }

    animateSprite = _ => {
        const { camera } = this.props
        // Rotate circle to face camera but don't rotate sprite
        // Keeps margin of circle constant wrt sprite image
        this.pngSpriteObject.quaternion.copy(camera.quaternion)
        this.rafMesh = requestAnimationFrame(this.animateSprite)
    }

    render() {
        return null
    }
}

Sprite3D.defaultProps = {
    meshPosition: {
        x: 0,
        y: 0,
        z: 2,
    },
    spriteScale: {
        x: 0.1,
        y: 0.1,
        z: 0.1,
    },
}

export default Sprite3D
